import React, {useState} from 'react';
import axios from "axios";

const config = require('../../Config.json');

export default function ContactUs() {
    const [queryDetails, setQueryDetails]=useState({name:'', email:'', phoneNo:'', desc:''});
    const [transactionMsg, setTransactionMsg]=useState('');
    const [buttonClicked, setButtonClicked]=useState(false);

    const handleContactUsQuery=async(event)=>{
        event.preventDefault();
        setTransactionMsg('');
        setButtonClicked(true);
        try{
            //console.log("Query : ", queryDetails);
            const {name, email, phoneNo, desc} = queryDetails;
            if(name===""||email===""||desc===""||phoneNo===""){
              setTransactionMsg("Kindly fill all the details to share your Query/Feedback");
            }else{
              const inputParams={
                name : name,
                phoneNo : phoneNo,
                emailID : email,
                desc : desc
              };
              //console.log("Params : ", inputParams);
            await axios.post(`${config.api.invokeURL}/contact-us/query`, inputParams,{
              headers: {
              //Authorization: access_token,
              'x-api-key':config.api.key
              }})
              .then((response)=>{
                //console.log("Response : ", response);
                if (response.status===200){
                  setTransactionMsg("Thank you for your Query/feedback! our team will get back to you soon!");
                  setQueryDetails({...queryDetails, name:'', email:'', desc:'', phoneNo:''})
                  setButtonClicked(false);
                }
              })
              .catch((error)=>{
                //console.log("Error : ", error);
                setTransactionMsg("Error Occured : "+error.message);
                setButtonClicked(false);
              });
            }
            setButtonClicked(false);
        }catch(error){
            //console.log("error :", error);
            setTransactionMsg("Error : " + error.message )
        }
    }

  return (
    <div className="container-fluid py-2 mb-3" style={{  backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='250' preserveAspectRatio='none' viewBox='0 0 1440 250'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1003%26quot%3b)' fill='none'%3e%3cpath d='M17 250L267 0L556.5 0L306.5 250z' fill='url(%23SvgjsLinearGradient1004)'%3e%3c/path%3e%3cpath d='M274.6 250L524.6 0L818.6 0L568.6 250z' fill='url(%23SvgjsLinearGradient1004)'%3e%3c/path%3e%3cpath d='M512.2 250L762.2 0L879.2 0L629.2 250z' fill='url(%23SvgjsLinearGradient1004)'%3e%3c/path%3e%3cpath d='M745.8000000000001 250L995.8000000000001 0L1246.3000000000002 0L996.3000000000001 250z' fill='url(%23SvgjsLinearGradient1004)'%3e%3c/path%3e%3cpath d='M1434 250L1184 0L1131.5 0L1381.5 250z' fill='url(%23SvgjsLinearGradient1005)'%3e%3c/path%3e%3cpath d='M1200.4 250L950.4000000000001 0L662.4000000000001 0L912.4000000000001 250z' fill='url(%23SvgjsLinearGradient1005)'%3e%3c/path%3e%3cpath d='M934.8 250L684.8 0L414.79999999999995 0L664.8 250z' fill='url(%23SvgjsLinearGradient1005)'%3e%3c/path%3e%3cpath d='M699.1999999999999 250L449.19999999999993 0L264.69999999999993 0L514.6999999999999 250z' fill='url(%23SvgjsLinearGradient1005)'%3e%3c/path%3e%3cpath d='M1290.018712643683 250L1440 100.01871264368319L1440 250z' fill='url(%23SvgjsLinearGradient1004)'%3e%3c/path%3e%3cpath d='M0 250L149.9812873563168 250L 0 100.01871264368319z' fill='url(%23SvgjsLinearGradient1005)'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1003'%3e%3crect width='1440' height='250' fill='white'%3e%3c/rect%3e%3c/mask%3e%3clinearGradient x1='0%25' y1='100%25' x2='100%25' y2='0%25' id='SvgjsLinearGradient1004'%3e%3cstop stop-color='rgba(15%2c 70%2c 185%2c 0.2)' offset='0'%3e%3c/stop%3e%3cstop stop-opacity='0' stop-color='rgba(15%2c 70%2c 185%2c 0.2)' offset='0.66'%3e%3c/stop%3e%3c/linearGradient%3e%3clinearGradient x1='100%25' y1='100%25' x2='0%25' y2='0%25' id='SvgjsLinearGradient1005'%3e%3cstop stop-color='rgba(15%2c 70%2c 185%2c 0.2)' offset='0'%3e%3c/stop%3e%3cstop stop-opacity='0' stop-color='rgba(15%2c 70%2c 185%2c 0.2)' offset='0.66'%3e%3c/stop%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e")`, 
    backgroundPosition: "bottom", backgroundRepeat: "no-repeat", backgroundSize: "cover", paddingB: "50px"}}>
    <div className="container" >
        <div className="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style={{maxWidth: "600px"}}>
            <h1 className="mb-3 text-dark-main">Contact Us for any query</h1>
        </div>
        <div className="contact-detail position-relative p-2">
            <div className=" container row g-5 mb-5 justify-content-center"  style={{backgroundColor:"mintcream", borderRadius:"25px"}}>
                <div className="col-xl-4 col-lg-6 wow fadeIn" data-wow-delay=".3s">
                    <div className="d-flex bg-light p-2 rounded">
                        <div className="flex-shrink-0 btn-square Ylight-bg rounded-circle" style={{width: "64px", height: "84px"}}>
                            <i className="fa fa-map-marker text-dark-main" style={{fontSize:"60px"}}></i>
                        </div>
                        <div className="ms-3">
                            <h4 className="text-primary">Address</h4>
                            <a href="https://maps.app.goo.gl/hCvFR6QuMTPqKwEk6" target="_blank" className="h6">107, Padikuppam Road, Kamaraj nagar, Chennai – 600040</a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 wow fadeIn" data-wow-delay=".5s">
                    <div className="d-flex bg-light p-2 rounded">
                        <div className="flex-shrink-0 btn-square Ylight-bg rounded-circle" style={{width: "64px", height: "64px"}}>
                            <i className="fa fa-phone text-dark-main" style={{fontSize:"60px"}}></i>
                        </div>
                        <div className="ms-3">
                            <h4 className="text-primary">Call Us</h4>
                            <a className="h6" href="tel:+0123456789" target="_blank">(+91) 97890 91634</a>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 wow fadeIn" data-wow-delay=".7s">
                    <div className="d-flex bg-light p-3 rounded">
                        <div className="flex-shrink-0 btn-square Ylight-bg rounded-circle" style={{width: "64px", height: "64px"}}>
                            <i className="fa fa-envelope text-dark-main" style={{fontSize:"60px"}}></i>
                        </div>
                        <div className="ms-3">
                            <h4 className="text-primary">Email Us</h4>
                            <a className="h6" href="mailto:info@example.com" target="_blank">josephrathinaraj@gmail.com</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row g-5 container">
                <div className="col-lg-6 wow fadeIn card" data-wow-delay=".3s">
                    <div className="p-1 h-100 rounded Ylight-bg container">
                        <iframe className="rounded w-100 h-100" style={{border:"0"}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d485.78172100664693!2d80.19165552984745!3d13.083097012425457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52640169defe7d%3A0xc909d3a2e0d98d54!2s107%2C%20Padikuppam%20Main%20Rd%2C%20Kamaraj%20Nagar%2C%20Anna%20Nagar%20West%2C%20Anna%20Nagar%20West%20Extension%2C%20Chennai%2C%20Tamil%20Nadu%20600107!5e0!3m2!1sen!2sin!4v1716568498042!5m2!1sen!2sin" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
                <div className="col-lg-6 wow fadeIn container card" data-wow-delay=".5s">
                    <div className="p-1 rounded Ylight-bg">
                        <div className="mb-4">
                            <input type="text" className="form-control py-3" placeholder="Your Name" value={queryDetails.name} onChange={event=>setQueryDetails({...queryDetails, name:event.target.value})}/>
                        </div>
                        <div className="mb-4">
                            <input type="email" className="form-control py-3" placeholder="Your Email" value={queryDetails.email} onChange={event=>setQueryDetails({...queryDetails, email:event.target.value})}/>
                        </div>
                        <div className="mb-4">
                            <input type="text" className="form-control py-3" placeholder="Phone No" value={queryDetails.phoneNo} onChange={event=>setQueryDetails({...queryDetails, phoneNo:event.target.value})}/>
                        </div>
                        <div className="mb-4">
                            <textarea className="w-100 form-control py-3" rows="6" cols="10" placeholder="Message" value={queryDetails.desc} onChange={event=>setQueryDetails({...queryDetails, desc:event.target.value})}></textarea>
                        </div>
                        <div className="mb-4">
                            {transactionMsg}
                            </div>
                        <div className="text-center p-2">
                            <button className="primary py-2 px-2"  type="button" onClick={event=>handleContactUsQuery(event)}>Send Message</button>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div> 
</div>
  )
}